import styled, { css } from 'styled-components';

export const PluginGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
`;

const iconControlStyles = css`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: #424242;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    text-decoration: none;

    &:hover {
        background: #f2f2f2;
        color: #212121;
        text-decoration: none;
    }

    &:focus-visible {
        outline: 2px solid #303f9f;
        outline-offset: 1px;
    }

    &:disabled,
    &[aria-disabled='true'] {
        color: #9e9e9e;
        cursor: not-allowed;
    }
`;

export const PluginIconLink = styled.a`
    ${iconControlStyles}
`;

export const PluginIconButton = styled.button`
    ${iconControlStyles}
`;

export const PluginBadge = styled.span`
    position: absolute;
    top: 1px;
    right: 0;
    min-width: 15px;
    height: 15px;
    padding: 0 4px;
    border-radius: 8px;
    background: #d32f2f;
    color: #ffffff;
    font-size: 9px;
    font-weight: 700;
    line-height: 15px;
    text-align: center;
`;
